import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Spinner, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import { CaboloStatusEnum } from "../../app/models/cabolo";
import { use } from "i18next";
import GenericModal from "../common/GenericModal";
import CaboloForm from "../forms/CaboloForm";
import { runInAction } from "mobx";

const CaboloRecordingButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { attendingMeeting } = rootStore.playerStore;
  const [t] = useTranslation(["translation", "cabolo"], translationHookOptions);

  const { isMobileMediaQuery, setIsSidebarModalOpen, isSidebarModalOpen } = rootStore.responsiveStore;
  const {CaboloStatus, getCaboloStatus,getCaboloInfoMeeting,caboloMeetigInfo, getRecStatus, IsRecordingCurrentMeeting, loadingCaboloStatus}= rootStore.caboloStore;

// const [loadingStatusRequest, setLoadingStatusRequest] = useState(false);

const[isOpenModalRegistrations, setIsOpenModalRegistrations] = useState(false);
const {  broadcastLauncherTypes, broadcastUser } = rootStore.broadcastStore;

// useEffect(() => {
//   let intervalId: NodeJS.Timeout | null = null;
//   let caboloId: number | null = null;

//   if (attendingMeeting) {
//     setLoadingStatusRequest(true); // mostra la clessidra subito

//     getCaboloInfoMeeting(attendingMeeting.id)
//       .then((dto) => {
//         if (dto && dto.caboloId > 0) {
//           caboloId = dto.caboloId;

//           // Esegui subito una prima richiesta
//           getCaboloStatus(caboloId).then((dto) => {
//            if(dto){
//             getRecStatus(caboloId??0, dto.status)
//            }

//           });
        
//           // Imposta il polling ogni 1 secondo
//           intervalId = setInterval(() => {
//             getCaboloStatus(dto.caboloId).then((dto) => {
//                if (dto) {
//                 getRecStatus(caboloId ?? 0, dto.status);
//               }
//             }
//           );
//           }, 1000);
//         }
//       })
//       .finally(() => setLoadingStatusRequest(false))
//       .catch(() => setLoadingStatusRequest(false));
//   }

//   // Pulizia dell'intervallo al dismount o cambio meeting
//   return () => {
//     if (intervalId) {
//       clearInterval(intervalId);
//     }
//   };
// }, [attendingMeeting]);


useEffect(() => {
  let isCancelled = false;
  let isFirstCall = true;

  const poll = async () => {
    try {
      if(attendingMeeting){
      const info = await getCaboloInfoMeeting(attendingMeeting!.id);
      if (info?.caboloId) {
      var dto=  await getCaboloStatus(info.caboloId, isFirstCall);
        if (isFirstCall) isFirstCall = false;
        if (dto) {
          getRecStatus(info.caboloId, dto.status);
        } 
      }
    }
    } catch (err) {
      console.error("Polling error", err);
    } finally {
      if (!isCancelled) {
        setTimeout(poll, 3000); // continua il polling
      }
    }
  };

  if (attendingMeeting) {
    poll(); // avvia il polling
  }

  return () => {
    isCancelled = true;
  };
}, [attendingMeeting]);


const getStatusIcon = () => {
  const tooltipId = "caboloStatusTooltip";
  var tooltipText = t(`${CaboloStatus}`, { ns: "cabolo" });

  let iconClass = "";
  let iconName = "";

  switch (CaboloStatus) {
    case CaboloStatusEnum.STATE_READY:
      iconName = "fa-play";
      iconClass = "text-default";
      break;

    case CaboloStatusEnum.STATE_PLAYING:
      iconName = "fa-play";
      iconClass = "text-danger blink-play-cabolo";
      break;

    case CaboloStatusEnum.STATE_PAUSED:
      iconName = "fa-pause";
      iconClass = "text-default";
      break;

    case CaboloStatusEnum.STATE_WAITING:
    case CaboloStatusEnum.STATE_LOADING:
    case CaboloStatusEnum.STATE_CHANGE_READY_TO_PLAY:
    case CaboloStatusEnum.STATE_CHANGE_PLAY_TO_PAUSE:
    case CaboloStatusEnum.STATE_CHANGE_PAUSE_TO_PLAY:
    case CaboloStatusEnum.STATE_CHANGE_PLAY_TO_READY:
    case CaboloStatusEnum.STATE_CHANGE_PAUSE_TO_READY:
    case CaboloStatusEnum.STATE_CHANGE_PLAY_TO_WAITING:
    case CaboloStatusEnum.STATE_CHANGE_PAUSE_TO_WAITING:
      iconName = "fa-spinner fa-spin";
      iconClass = "text-default";
      break;

    case CaboloStatusEnum.STATE_ERROR_CONNECTION:
    case CaboloStatusEnum.STATE_INTERRUPTED:
    case CaboloStatusEnum.STATE_MOVE_INTERRUPTED:
      iconName = "fa-exclamation-triangle";
      iconClass = "text-danger";
      break;

    case CaboloStatusEnum.STATE_LICENSE_EXPIRED:
    case CaboloStatusEnum.STATE_LOCKED:
      iconName = "fa-lock";
      iconClass = "text-muted";
      break;

    default:
    tooltipText = t(`${CaboloStatusEnum.STATE_ERROR_CONNECTION}`, { ns: "cabolo" });
     iconName = "fa-exclamation-triangle";
      iconClass = "text-danger";
      break;
  }

  return (
    <>
      <span id={tooltipId}>
        <i style={{marginTop:"8px", marginLeft:"2px"}} className={`fas ${iconName} ${iconClass}`} />
      </span>
      <UncontrolledTooltip delay={0} placement="right" target={tooltipId}>
        {tooltipText}
      </UncontrolledTooltip>
    </>
  );
};


return (
  <>
    {attendingMeeting && caboloMeetigInfo && caboloMeetigInfo.caboloId > 0 && currentTenant && (
      <Button
    
        color="light"
        onClick={() => {setIsOpenModalRegistrations(true)}}
        className="navbarButton navbarButtonEnabled d-flex align-items-center justify-content-between px-2"
        // se non c'è il bottnen di broadcast, metto un margine a destra per farlo staccare dal bottone esci
        style={{ width: "3rem", minWidth: "3rem", marginRight: broadcastLauncherTypes && broadcastLauncherTypes !== "undefined" ? "":"2rem" }}
        disabled={
          CaboloStatus === CaboloStatusEnum.STATE_INTERRUPTED
            ? false
            : (
                !IsRecordingCurrentMeeting ||
                loadingCaboloStatus ||
                ![
                  CaboloStatusEnum.STATE_READY,
                  CaboloStatusEnum.STATE_PLAYING,
                  CaboloStatusEnum.STATE_PAUSED,
                ].includes(CaboloStatus as CaboloStatusEnum)
              )
        }
      >
        {caboloMeetigInfo.hasEnabledRegistrationCabolo && caboloMeetigInfo.caboloId > 0 && (
          <i style={{marginTop:"1px"}} className="fas fa-microphone-alt" />
        )}
        <span>
          {loadingCaboloStatus  ? (
              <i  style={{marginTop:"6px", marginLeft:"2px"}} className="fas fa-spinner fa-spin text-default" />
          ) : (
            getStatusIcon()
          )}
        </span>
      </Button>
    )}
    <GenericModal isOpen={isOpenModalRegistrations} 
        // title=""
      size="md"
       title={t("title_recording", { ns: "cabolo" })}
      toggle={()=> setIsOpenModalRegistrations(false)}
      content={ 
        <>
        <CaboloForm  toggle= { ()=>setIsOpenModalRegistrations(false)}></CaboloForm>
        </>
    
      }
      cancelBtn={false}
      ></GenericModal>
  </>
);
};

export default observer(CaboloRecordingButton);
